import { render, staticRenderFns } from "./Warning.vue?vue&type=template&id=c8b3dac0&scoped=true"
import script from "./Warning.vue?vue&type=script&lang=js"
export * from "./Warning.vue?vue&type=script&lang=js"
import style0 from "./Warning.vue?vue&type=style&index=0&id=c8b3dac0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b3dac0",
  null
  
)

export default component.exports